<template>
  <div>
    <div class="topic-search">
      <div class="search">
        <div class="search-input">
          <van-icon name="search" class="search-icon"></van-icon>
          <input

            type="text"
            maxlength="20"
            v-model="searchtext"
            @input="getsearch"
            placeholder="#话题关键字"
            confirm-type="search"
          />
          <div class="close" v-if="searchtext" @click="closesearch">
            <van-icon
              name="clear"
              class="van-icon van-icon-clear van-uploader__preview-delete"
              color="#999999"
            ></van-icon>
          </div>
        </div>
<!--        <div class="search-btn" @click="searchTopic()">搜索</div>-->
      </div>
      <div class="hot_span" v-if="searchtext==''">
        <span v-if="state==1 && searchList.length">热门话题</span>
      </div>
      <div v-if="!newTopic ">
        <div class="search-list"  style="margin-top: 0.1rem" @click="addTopic()" v-if="searchtext!=''&& state!=1">
          <img :src="logoUrl"  style="background-color: #131825">
          <div class="search-list-content">
            <p>#{{searchtext}}#</p>
            <span>新建话题</span>
          </div>
        </div>
        <div class="fenge" v-if="searchtext!=''&& state!=1">
          <span>
            相关推荐
          </span>
        </div>

        <div class="search-list" v-for="(item,index) in searchList" :key="index" @click="goRelease(item.id)">
          <img :src="item.logoUrl"  v-if="item.logoUrl">
          <img src="https://img.zhanshangxiu.com/showonline/file/202009/976f30b982904045aeec14be2bb0dea2.png"  v-else>
          <div class="search-list-content">
            <p>#{{item.title}}#</p>
            <span>阅读数：{{item.viewCount}}/讨论数：{{item.talkCount}}</span>
          </div>
        </div>

      </div>
      <div v-if="newTopic&&searchtext!=''">
        <div class="search-list" @click="addTopic()">
          <img :src="logoUrl"  style="background-color: #131825">
          <div class="search-list-content">
            <p>#{{searchtext}}#</p>
            <span>新建话题</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import gql from 'graphql-tag'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data() {
    return {
      showBg: true,
      searchtext: "",
      searchList: [],
      newTopic: false,
      relepase:[],
      value:'',
      state:0,//是否有新建话题状态判断
      state1:0,
      logoUrl: "https://img.zhanshangxiu.com/showonline/file/202009/976f30b982904045aeec14be2bb0dea2.png",
      pageSize:20,
      pageIndex:1,
      queryTheme:{},
    };
  },
  components: {},

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    ThemeGql(){
        return gql `query
                queryTheme($query: QueryInput!){
                    queryTheme(query:$query){
                       hasNextPage
                       pageIndex
                       totalCount
                       items{
                        content
                        createAt
                        followCount
                        id
                        isDeleted
                        exhibitionId
                        logoUrl
                        memberId
                        publisherName
                        publisherType
                        shareCount
                        summary
                        talkCount
                        title
                        topic
                        topicIndex
                        userCount
                        viewCount
                       }
                    }
                }`
      },
  },
  created() {
    this.searchTopic();
  },
  mounted(){

  },
  methods: {
    ...mapActions({
      TopicSearch: "topicSupply/TopicSearch",
      AddTopic: "topicSupply/AddTopic",
      LinkTohotPub: "linkTo/LinkTohotPub",
      getQueryTopic: "topicSupply/getQueryTopic",
      getTopicOne: "topicSupply/getTopicOne",
    }),
    getsearch(e){
      console.log(this.searchtext)
      delay(()=>{
        this.searchtext=this.searchtext.replace(/\s+/g,'')
        console.log('111111')
        this.searchTopic()
      },1000)

    },
    closesearch() {
      this.searchtext = "";
      this.searchTopic();

    },
    searchData(option){
      let where = {
          "Equal":{
            "n":"isDeleted",
            "v":0
          },
          "Equal2":{
            "n":"exhibitionId",
            "v":this.exhibitionId
          },
          ...option
      };
      return new Promise((resolve, reject) => {
        this.$apollo.addSmartQuery("queryTheme",{
          query:this.ThemeGql,
          variables:{
            query:{
              page: this.pageIndex,
              size: this.pageSize,
              where:JSON.stringify(where),
            }
          },
          fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
          result(data){
            if(data&&data.data.queryTheme.items.length){
              this.searchList = data.data.queryTheme.items;
              console.log( this.searchList,'this.List-----');
              resolve(data.data.queryTheme.items);
            }
          },
          error(err){
            console.log(err,'请求错误')
          }
        })
      });
    },

    //查询话题
    async searchTopic() {
      console.log( this.$route.path)
      this.state=0
      this.state1=0
      if(this.searchtext!=''){
        let opt = {
          "Liketitle":{
            "n":"title",
            "v":`%${this.searchtext}%`
          },
        };
        this.pageSize = 10;
        let data = await this.searchData(opt);
        if ( data.length > 0) {
          console.log("大于0");
          this.newTopic = false;
        } else {
          console.log("小于0");
          this.newTopic = true;
        }
        data.forEach(v=>{
          if(v.title==this.searchtext){
            this.state=1
          }
        })

      }
      else {
        this.state=1;
        let opt = {
            "GreaterThan":{
              "n":"topic",
              "v":0
            },
        }
        this.pageSize = 6;
        let data = await this.searchData(opt);
        this.newTopic = false;
      }

    },
    //新建话题
    async addTopic() {
      if (this.searchtext!=''){
        // console.log("chufa");
        let opt = {
          memberId: this.userInfo.id,
          title: this.searchtext,
          logoUrl: this.logoUrl,
          exhibitionId:this.exhibitionId,
          publisherType:0,
          publisherName:this.userInfo.name
        };
        let data = await this.AddTopic(opt);
        if (data.result && data) {
          let opt = {
            id: false,
            topicId: data.data,
          };
         await this.goRelease(opt.topicId)
          // this.$router.go(-1);
        }
      }
      else{
        this.$toast.fail('不能新建空话题')
      }

    },
   async goRelease(topicId) {
      let opt = {
        id: false,
      };
      if (topicId){
        if(localStorage.getItem("relepase")){
          this.relepase=JSON.parse(localStorage.getItem("relepase"))
        }
        if (this.relepase.length>0){
          for(let i=0;i<this.relepase.length;i++){
            if (this.relepase[i].id!=topicId){
              let topicList = await this.getTopicOne(topicId);
              this.relepase.push(topicList.data);
            }
          }
        }
        else{
          let topicList = await this.getTopicOne(topicId);
          this.relepase.push(topicList.data);
        }

        localStorage.setItem("relepase", JSON.stringify(this.relepase))
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
.topic-search {
  height: 100vh;
  background-color: #fff;
  overflow-y: auto;
  .fenge{
    height: 0.54rem;
    margin-top: 0.3rem;
    margin-bottom: 0.1rem;
    background-image: linear-gradient(90deg,
            #f0f2fa 0%,
            #fff 100%),
    linear-gradient(
                    #eeeeee,
                    #eeeeee);
    background-blend-mode: normal,
    normal;
    display: flex;
    align-items: center;
    span{
      font-size:0.22rem;
      color: #666;
      margin-left: 0.3rem;
    }
  }
  .hot_span{
    padding: 0.2rem 0 0 0.3rem;
    span{
      font-size: 0.3rem;
      color: #333;
      font-weight: bold;
    }
  }
  .search {
    padding: 0.2rem 0.2rem 0.2rem 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-input {
      display: flex;
      align-items: center;
      width: 7.12rem;
      height: 0.64rem;
      background-color: #f2f2f2;
      border-radius: 0.32rem;
      position: relative;
      input {
        position: absolute;
        left: 0.71rem;
        background-color: #f2f2f2;
        border: none;
        width: 70%;
      }
      .close {
        position: absolute;
        right: 0.3rem;
      }
    }
    &-icon{
       margin:.2rem .16rem .2rem .3rem;
       color:#666;
       font-size: .25rem;
    }
    &-btn {
      margin-left: 0.2rem;
      color: #ff5c00;
      font-size: 0.3rem;
    }
  }
  .search-list {
    display: flex;
    padding: 0 0.3rem;
    margin-top: 0.3rem;
    img {
      width: 0.9rem;
      height: 0.9rem;
      margin-right: 0.2rem;
      border-radius: 3px;
    }
    &-content {
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
        max-width: 5rem;
      }
      span {
        color: #666;
        font-size: 0.22rem;
        display: block;
        margin-top: 0.15rem;
      }
    }
  }
}
</style>

